(() => {
  function calendarDay(timeZone) {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone, year: 'numeric', month: '2-digit', day: '2-digit'
    });
    const parts = Object.fromEntries(formatter.formatToParts(new Date()).map(part => [part.type, part.value]));
    return new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
  }

  function businessDate(start, count, holidays) {
    const date = new Date(start);
    let remaining = count;
    // Starting tomorrow avoids promising same-day dispatch without a verified cutoff.
    while (remaining > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      const weekday = date.getUTCDay();
      if (weekday !== 0 && weekday !== 6 && !holidays.has(date.toISOString().slice(0, 10))) remaining--;
    }
    return date;
  }

  function update(node) {
    const values = ['processingMin', 'processingMax', 'transitMin', 'transitMax']
      .map(key => Number(node.dataset[key]));
    if (values.some(value => !Number.isInteger(value) || value < 0 || value > 90)) return;
    const [processingMin, processingMax, transitMin, transitMax] = values;
    if (processingMax < processingMin || transitMax < transitMin) return;
    const holidays = new Set((node.dataset.holidays || '').split(/[\s,;]+/)
      .filter(value => /^\d{4}-\d{2}-\d{2}$/.test(value)));
    let today;
    try { today = calendarDay(node.dataset.timeZone || 'America/New_York'); }
    catch (_) { today = calendarDay('UTC'); }
    const earliest = businessDate(today, processingMin + transitMin, holidays);
    const latest = businessDate(today, processingMax + transitMax, holidays);
    let formatter;
    const options = { month: 'short', day: 'numeric', timeZone: 'UTC' };
    if (earliest.getUTCFullYear() !== today.getUTCFullYear() || latest.getUTCFullYear() !== today.getUTCFullYear()) options.year = 'numeric';
    try { formatter = new Intl.DateTimeFormat(node.dataset.locale || 'en', options); }
    catch (_) { formatter = new Intl.DateTimeFormat('en', options); }
    const range = node.querySelector('[data-delivery-range]');
    if (!range) return;
    range.textContent = earliest.getTime() === latest.getTime()
      ? formatter.format(earliest)
      : `${formatter.format(earliest)} – ${formatter.format(latest)}`;
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-delivery-estimate]').forEach(node => {
      update(node);
      if (node.dataset.deliveryInitialized) return;
      node.dataset.deliveryInitialized = 'true';
      const purchase = node.closest('aside');
      const select = purchase?.querySelector('select[name="id"]');
      if (select) {
        const availability = () => {
          node.hidden = select.selectedOptions[0]?.dataset.available === 'false';
        };
        select.addEventListener('change', availability);
        availability();
      }
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) initialize(); });
  // Refresh an open product page after midnight without a page reload.
  setInterval(initialize, 60000);
})();
